import { defineMessages } from 'react-intl';
import { allCountries } from 'country-telephone-data';

const placeholderMessages = allCountries.reduce(
  (previousValue, curentValue) => ({
    ...previousValue,
    [curentValue.iso2]: {
      id: `app.containers.information.phone.number.placeholder.${curentValue.iso2}`,
      defaultMessage: curentValue.format || '',
    },
  }),
  {}
);

export default defineMessages({
  label: {
    id: 'app.containers.information.phone.number.label',
    defaultMessage: 'Phone number',
  },
  invalid: {
    id: 'app.containers.information.phone.number.invalid',
    defaultMessage: 'This phone number is not valid.',
  },
  preferred: {
    id: 'app.containers.information.phone.number.preferred',
    defaultMessage: 'Preferred',
  },
  all: {
    id: 'app.containers.information.phone.number.all',
    defaultMessage: 'All',
  },
  ...placeholderMessages,
});
